module.exports = __webpack_public_path__ + "img/product-xr2-m.dfb48d75.jpg";